import File from "./File";
const initFile = (element) => {
    new File(element);
}

export {
    File,
    initFile,
}
